import styled from 'styled-components';
import { breakpoints } from '@upright/ui/common/generic/global/breakpoints';

interface NoProductsEmptyStateProps {
  onAddProduct: () => void;
}

export function NoProductsEmptyState({ onAddProduct }: NoProductsEmptyStateProps) {
  return (
    <Root>
      <Container>
        <Title>Unfortunately we weren't able to retrieve the products and services for your company</Title>
        <Description>
          Please add your most important products and services to continue. You can add more later on.
        </Description>
        <AddProductButton onClick={onAddProduct}>+ Add product</AddProductButton>
      </Container>
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 450px;
  border: 1px solid var(--color__gray-200);
  border-radius: var(--border-radius__xl);
  background-color: var(--platform-gray-100);
  padding: var(--space__xl);
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space__xl);
  text-align: center;
  max-width: 600px;
`;

const Title = styled.p`
  font-size: var(--font-size__md);
  font-weight: var(--font-weight__bold);
  color: var(--platform-gray-800);
  margin: 0;
  line-height: 1.4;
  max-width: 326px;
`;

const Description = styled.p`
  font-size: var(--font-size__md);
  color: var(--platform-gray-600);
  margin: 0;
  line-height: 1.4;
  max-width: 326px;
`;

const AddProductButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space__sm);
  padding: var(--space__xs) var(--space__lg);
  border: 1px solid var(--borderColor-default);
  background-color: white;
  border-radius: var(--border-radius__md);
  color: var(--platform-gray-800);
  font-size: var(--font-size__md);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: var(--canvas-inset);
    border-color: var(--borderColor-muted);
  }

  &:active {
    background-color: var(--canvas-subtle);
  }

  @media (max-width: ${breakpoints[0]}) {
    width: 100%;
  }
`;
